import React from "react";
import { Crown, TrendingUp, Users, Zap } from "lucide-react";
import { formatScore } from "./leaderboardHelpers";

const METRICS = [
  { key: "ranked", label: "Ranked", icon: Users },
  { key: "avg", label: "Avg", icon: TrendingUp },
  { key: "peak", label: "Peak", icon: Zap },
  { key: "tier", label: "Top tier", icon: Crown },
];

export default function LeaderboardStatsBand({ stats, totalRanked, loading }) {
  const avg = stats?.averageScore ?? 0;
  const max = stats?.maxScore ?? 0;
  const levels = stats?.levelDistribution || [];
  const topLevel = levels[0];

  const values = {
    ranked: totalRanked ?? stats?.totalUsers ?? "—",
    avg: loading ? "…" : formatScore(avg),
    peak: loading ? "…" : formatScore(max),
    tier: topLevel?._id || "—",
  };

  const subs = {
    tier: topLevel ? `${topLevel.count} in tier` : null,
  };

  return (
    <div className="alb-metrics" aria-label="Leaderboard statistics">
      <div className="alb-metrics-track">
        {METRICS.map(({ key, label, icon: Icon }, idx) => (
          <div
            key={key}
            className={`alb-metric alb-metric-${key}${idx < METRICS.length - 1 ? " alb-metric-divide" : ""}`}
          >
            <span className="alb-metric-icon" aria-hidden>
              <Icon size={10} strokeWidth={2.2} />
            </span>
            <span className="alb-metric-copy">
              <span className="alb-metric-label">{label}</span>
              <span className="alb-metric-value tabular-nums">
                {values[key]}
                {subs[key] ? (
                  <em className="alb-metric-sub">{subs[key]}</em>
                ) : null}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
